import type { CyanGoal, CyanGoalPlan, CyanGoalStep } from "./types";
import { evaluateGoalPlanApproval } from "./goalTakeoverContract";

export interface GoalPlanningInput {
  goal: CyanGoal;
  proposedSteps: CyanGoalStep[];
}

export class CyanGoalOrchestrator {
  createPlan(input: GoalPlanningInput): CyanGoalPlan {
    const basePlan = {
      goal: input.goal,
      steps: input.proposedSteps,
    };

    return {
      ...basePlan,
      ...evaluateGoalPlanApproval(basePlan),
    };
  }

  getExecutableSteps(plan: CyanGoalPlan): CyanGoalStep[] {
    return plan.steps.filter((step) => {
      if (step.status !== "ready") return false;

      return step.dependencies.every((dependencyId) => {
        const dependency = plan.steps.find(
          (candidate) => candidate.id === dependencyId,
        );

        return dependency?.status === "completed";
      });
    });
  }
}
